import 'css-chunk:src/Contact/Contact.module.scss';export default {
  "card_title_img": "card_title_img__uJd2F",
  "bg": "bg__vbWCC"
};